import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { RouterProvider } from "react-router-dom";
import Router from "./routes";
import { AuthProvider } from "./context/AuthContext";
import { CompanyProvider } from "./context/CompanyContext";
import { OrganizationBranchProvider } from "./context/OrganizationBranchContext";
import { InvoiceProvider } from "./context/InvoiceContext";
import { CustomerProvider } from "./context/CustomerContext";
import { VendorProvider } from "./context/VendorContext";
import { PaymentProvider } from "./context/PaymentContext";
import { ProductProvider } from "./context/ProductContext";
import { CategoryProvider } from "./context/CategoryContext";
import { ThemeProvider } from "./context/ThemeContext";
import { UnitOfMeasureProvider } from "./context/UnitOfMeasureContext";
import { ServiceProvider } from "./context/ServiceContext";
import { PurchaseProvider } from "./context/PurchaseContext";
import { InventoryProvider } from "./context/InventoryContext";
import { StockIntegrationProvider } from "./context/StockIntegrationContext";
import { ReportProvider } from "./context/ReportContext";
import { CreditNoteProvider } from "./context/CreditNoteContext";
import { DepartmentProvider } from "./context/DepartmentContext";
import { UserProvider } from "./context/UserContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <UserProvider>
          <OrganizationBranchProvider>
            <CompanyProvider>
            <DepartmentProvider>
              <CustomerProvider>
                <VendorProvider>
                  <ProductProvider>
                    <CategoryProvider>
                      <UnitOfMeasureProvider>
                        <ServiceProvider>
                          <InvoiceProvider>
                            <PaymentProvider>
                              <PurchaseProvider>
                                <InventoryProvider>
                                  <StockIntegrationProvider>
                                    <ReportProvider>
                                      <CreditNoteProvider>
                                        <RouterProvider router={Router} />
                                      </CreditNoteProvider>
                                    </ReportProvider>
                                  </StockIntegrationProvider>
                                </InventoryProvider>
                              </PurchaseProvider>
                            </PaymentProvider>
                          </InvoiceProvider>
                        </ServiceProvider>
                      </UnitOfMeasureProvider>
                    </CategoryProvider>
                  </ProductProvider>
                </VendorProvider>
              </CustomerProvider>
            </DepartmentProvider>
            </CompanyProvider>
          </OrganizationBranchProvider>
        </UserProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
